/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CommonBreadcrumbs.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React from "react";
import { Breadcrumbs, Typography } from "@mui/material";

const CommonBreadcrumbs = ({ items = [], color = null, fontSize = null }) => {
  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator="/"
      sx={{ ...baseStyle, color: color || "#000000" }}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <Typography
            key={item.label + index}
            sx={{
              ...baseStyle,
              fontWeight: isLast ? 600 : 400,
              color: isLast ? "#000000" : color || "#26890D",
              cursor: item.onClick ? "pointer" : "default",
              ...(fontSize && { fontSize: fontSize }),
            }}
            onClick={item.onClick}
          >
            {item.label}
          </Typography>
        );
      })}
    </Breadcrumbs>
  );
};

export default CommonBreadcrumbs;

const baseStyle = {
  // fontFamily: "Open Sans",
  fontStyle: "Open Sans",
  fontSize: "14px",
  lineHeight: "20px",
};
